import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-table-cells-icon',
  templateUrl: 'table-cells-icon.component.html'
})
export class TableCellsIconComponent {
  constructor() {}
}
